import { css, type Theme } from "@emotion/react";

export const header = css`
  height: auto;
  padding: 1rem;
`;

export const close = (theme: Theme) => css`
  cursor: pointer;

  path {
    fill: ${theme.text.body};
  }
`;

export const fullHeight = css`
  height: 100%;
`;
